"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledPropertyCardSaveButton = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _PropertyCardSaveButtonMixin = require("../../mixins/components/PropertyCardSaveButtonMixin");
var _ToggleButton = require("../ToggleButton/ToggleButton");
var StyledPropertyCardSaveButton = /*#__PURE__*/(0, _styledComponents.default)(_ToggleButton.ToggleButton).withConfig({
  displayName: "StyledPropertyCardSaveButton",
  componentId: "c11n-8-107-0__sc-ianvq6-0"
})(["", ""], _PropertyCardSaveButtonMixin.PropertyCardSaveButtonMixin);
exports.StyledPropertyCardSaveButton = StyledPropertyCardSaveButton;